export default __webpack_public_path__ + "static/media/custom4.66c12269.png";